// Add this import at the top
import moment from 'moment';
import { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import DatePicker from 'react-datepicker';

import 'react-datepicker/dist/react-datepicker.css';

// Then inside your ProfileBlock component, before the return statement, add this modal component:
const EnrollImmunizationModal = ({ show, onClose, onConfirm, patientName, startDate, setStartDate }) => {
	const [localStartDate, setLocalStartDate] = useState(startDate || null);
	const [isSubmitting, setIsSubmitting] = useState(false);

	const handleConfirm = async () => {
		setIsSubmitting(true);
		try {
			if (setStartDate && localStartDate) {
				setStartDate(moment(localStartDate).format('YYYY-MM-DD'));
			}
			let date = moment(localStartDate).format('YYYY-MM-DD');
			await onConfirm(date);
			onClose();
		} catch (error) {
			console.error('Error:', error);
		} finally {
			setIsSubmitting(false);
		}
	};

	return (
		<Modal show={show} onHide={onClose} centered>
			<Modal.Header>
				<Modal.Title>Enroll in Immunization</Modal.Title>
				<button
					type="button"
					onClick={onClose}
					disabled={isSubmitting}
					style={{
						position: 'absolute',
						right: '1rem',
						top: '1rem',
						background: 'transparent',
						border: 'none',
						fontSize: '1.5rem',
						fontWeight: 'bold',
						cursor: 'pointer',
						color: '#000',
						opacity: 0.5,
						padding: '0.5rem',
						lineHeight: 1,
					}}
					onMouseEnter={e => (e.target.style.opacity = '0.75')}
					onMouseLeave={e => (e.target.style.opacity = '0.5')}
				>
					×
				</button>
			</Modal.Header>
			<Modal.Body>
				<p>
					Are you sure you want to enroll <strong>{patientName}</strong> in immunization?
				</p>

				<div className="form-group mt-3">
					<label htmlFor="immunizationStartDate">Start Date (Optional)</label>
					<DatePicker
						id="immunizationStartDate"
						className="form-control"
						selected={localStartDate ? new Date(localStartDate) : null}
						onChange={date => setLocalStartDate(date)}
						dateFormat="yyyy-MM-dd"
						placeholderText="Select start date"
						maxDate={new Date()}
						isClearable
					/>
					<small className="text-muted d-block mt-1">Leave empty to use patient's date of birth</small>
				</div>
			</Modal.Body>
			<Modal.Footer>
				<Button variant="secondary" onClick={onClose} disabled={isSubmitting}>
					Cancel
				</Button>
				<Button variant="primary" onClick={handleConfirm} disabled={isSubmitting}>
					{isSubmitting ? 'Enrolling...' : 'Enroll'}
				</Button>
			</Modal.Footer>
		</Modal>
	);
};
export default EnrollImmunizationModal;
